<div class="spider-chart-container">
    <canvas #spiderCanvas></canvas>
</div>